module.exports = __webpack_public_path__ + "static/img/x_dark.c4c69afe.svg";